'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var DEFAULT_KEY_TYPE = 'ed25519';
var DEFAULT_KEY_SIZE = 2048;

function createGen(_ref) {
  var keychain = _ref.keychain;

  var gen = function gen(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      type: DEFAULT_KEY_TYPE,
      size: DEFAULT_KEY_SIZE
    };
    return keychain.createKey(name, options.type || DEFAULT_KEY_TYPE, options.size || DEFAULT_KEY_SIZE);
  };

  return withTimeoutOption.withTimeoutOption(gen);
}

exports.createGen = createGen;